export function includesAny(array1: string[], array2: string[]) {
  return array1.some((item) => array2.includes(item.toUpperCase()));
}
